import { useContext, useEffect, useState } from 'react';
import { ActivePageContext } from '@trinity/chat-components/components/Chat/context';
import { SidePanelExpandedContext } from './context';

type Props = {
  children: React.ReactNode;
};

export const SidePanelContainer = (props: Props) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { layout } = useContext(ActivePageContext);

  useEffect(() => {
    setIsExpanded(layout === 'side_chat');
  }, [layout]);

  return (
    <SidePanelExpandedContext.Provider value={[isExpanded, setIsExpanded]}>
      {props.children}
    </SidePanelExpandedContext.Provider>
  );
};
